// Status colour map, lifted from webapp2/src/constants/default.ts (the subset
// module-config actually references). Values are semantic colour names mapped
// to badge styles by the UI.
export const defaultStatusColor: Record<string, string> = {
  pending: 'light-blue',
  started: 'light-blue',
  Started: 'light-blue',
  completed: 'green',
  Completed: 'green',
  submitted: 'green',
  Submitted: 'green',
  Published: 'green',
  published: 'green',
  rejected: 'red',
  deleted: 'red',
  active: 'green',
};

// The single allowed set of user statuses across the app.
export const USER_STATUSES = [
  'active',
  'disabled',
  'deleted',
  'pending',
  'invited',
] as const;

export type UserStatus = (typeof USER_STATUSES)[number];

// Maps a user status to a badge style class.
export const userStatusBadge = (status?: string | null): string => {
  switch ((status ?? '').toLowerCase()) {
    case 'active':
      return 'badge--success';
    case 'pending':
    case 'invited':
      return 'badge--info';
    case 'disabled':
      return 'badge--warning';
    case 'deleted':
    // Terminal state of self-service account deletion — the record is kept
    // (soft delete), the account is simply unusable.
    case 'permanently-deleted':
      return 'badge--danger';
    default:
      return 'badge--info';
  }
};
